/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __extends } from "tslib";
import * as Models from "./models";
import * as Mappers from "./models/mappers";
import * as operations from "./operations";
import { GraphRbacManagementClientContext } from "./graphRbacManagementClientContext";
var GraphRbacManagementClient = /** @class */ (function (_super) {
    __extends(GraphRbacManagementClient, _super);
    /**
     * Initializes a new instance of the GraphRbacManagementClient class.
     * @param credentials Credentials needed for the client to connect to Azure.
     * @param tenantID The tenant ID.
     * @param [options] The parameter options
     */
    function GraphRbacManagementClient(credentials, tenantID, options) {
        var _this = _super.call(this, credentials, tenantID, options) || this;
        _this.signedInUser = new operations.SignedInUser(_this);
        _this.applications = new operations.Applications(_this);
        _this.deletedApplications = new operations.DeletedApplications(_this);
        _this.groups = new operations.Groups(_this);
        _this.servicePrincipals = new operations.ServicePrincipals(_this);
        _this.users = new operations.Users(_this);
        _this.objects = new operations.Objects(_this);
        _this.domains = new operations.Domains(_this);
        _this.oAuth2PermissionGrant = new operations.OAuth2PermissionGrantOperations(_this);
        return _this;
    }
    return GraphRbacManagementClient;
}(GraphRbacManagementClientContext));
// Operation Specifications
export { GraphRbacManagementClient, GraphRbacManagementClientContext, Models as GraphRbacManagementModels, Mappers as GraphRbacManagementMappers };
export * from "./operations";
//# sourceMappingURL=graphRbacManagementClient.js.map